export const init_member = {
    "firstName": "",
    "lastName": "",
    "email": "",
    "tel": "",
    "avatarLink": "",
    "actived": false,
    "visible": false,
    "approved": false,
}